<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {Link, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Menu from '@/pages/products/_menu.vue'

export default {
  components: {Link, Card, Menu},
  mixins: [FormElements, Changes],
  data() {
    return {
      productId: '',

      manufacture: {},
      type: {},
      type_tester: {},
      measuring_range: {},
      customers: [],
      customerOptions: [],

      form: useForm({
        manufacture_id: '',
        type_id: '',
        type_tester_id: '',
        measuring_range_id: '',
        checksum: '',
        version: '',
        code_number: '',
        certificate_number: '',
        type_approval_number: '',
        serial_number: '',
        entry_date: '',
        particularities: '',
        abbreviation: '',
        inspection_type: '',
        customer_ids: [],
      })
    }
  },
  methods: {
    setProduct(product) {
      this.productId = product.id;

      this.manufacture = product.manufacture ?? {};
      this.type = product.type ?? {};
      this.type_tester = product.type_tester ?? {};
      this.measuring_range = product.measuring_range ?? {};
      this.customers = product.customers ?? [];
      this.customerOptions = this.customers.map(customer => {
        return {
          label: customer.name,
          value: customer.id,
        }
      })
      product.customer_ids = this.customers.map(customer => customer.id) ?? [];

      this.form.defaults(Helpers.prepareFormDefaults(product));
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <Menu :product-id="productId"/>

  <div class="row g-4 mb-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Product</h2>

        <Select
            v-model="form.manufacture_id"
            name="manufacture_id"
            label="Fabrikaat"
            :form="form"
            :tags="true"
            :ajaxUrl="route('api.v1.products.manufactures.list')"
            :currentValueLabel="manufacture.name"
        />

        <Select
            v-model="form.type_id"
            name="type_id"
            label="Type"
            :form="form"
            :tags="true"
            :ajaxUrl="route('api.v1.products.types.list')"
            :currentValueLabel="type.name"
        />

        <Select
            v-model="form.type_tester_id"
            name="type_tester_id"
            label="Type tester"
            :form="form"
            :ajaxUrl="route('api.v1.products.tester_types.list')"
            :currentValueLabel="type_tester.name"
        />

        <Select
            v-model="form.measuring_range_id"
            name="measuring_range_id"
            label="Debiet Meetbereik"
            :form="form"
            :ajaxUrl="route('api.v1.products.measuring_ranges.list')"
            :currentValueLabel="measuring_range.name"
        />
      </Card>
    </div>

    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Details</h2>

        <Input
            :form="form"
            v-model="form.code_number"
            name="code_number"
            :required="true"
            label="Codenummer"
        />

        <Input
            :form="form"
            v-model="form.certificate_number"
            name="certificate_number"
            :required="true"
            label="Certificatennummer"
        />

        <Input
            :form="form"
            v-model="form.type_approval_number"
            name="type_approval_number"
            :required="true"
            label="Typegoedkeuringsnummer"
        />

        <Input
            :form="form"
            v-model="form.serial_number"
            name="serial_number"
            label="Serienummer"
        />

        <Input
            :form="form"
            v-model="form.checksum"
            name="checksum"
            :required="true"
            label="Controlesom"
        />

        <Input
            :form="form"
            v-model="form.version"
            name="version"
            :required="true"
            label="Versie"
        />

        <Input
            :form="form"
            v-model="form.entry_date"
            name="entry_date"
            :required="true"
            type="date"
            label="Invoerdatum"
        />

        <MultipleRadios
            groupClasses="mb-0"
            :form="form"
            v-model="form.inspection_type"
            name="inspection_type"
            :required="true"
            label="Keuringstype"
            :options="[
                {label: '1ste keuring', value: 'first_inspection'},
                {label: 'Herkeuring', value: 're_inspection'},
            ]"
        />

      </Card>
    </div>

    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Notitie</h2>

        <Textarea
            :form="form"
            v-model="form.particularities"
            name="particularities"
            type="textarea"
            label="Bijzonderheden"
        />

        <Input
            :form="form"
            v-model="form.abbreviation"
            name="abbreviation"
            label="Afkorting"
        />
      </Card>
    </div>

    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Klanten</h2>

        <Select
            v-model="form.customer_ids"
            groupClasses="mb-0"
            name="customer_ids"
            label="Klanten"
            :form="form"
            :multiple="true"
            :options="customerOptions"
            :ajaxUrl="route('api.v1.customers.list')"
        />
      </Card>
    </div>
  </div>

</template>